var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdealFuerSanitaerUndIndustrie = function SvgIdealFuerSanitaerUndIndustrie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Ideal_fuer_Sanitaer_und_Industrie_svg__Ebene_2",
    viewBox: "0 0 97.92 101.91"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Ideal_fuer_Sanitaer_und_Industrie_svg__cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2.86px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ideal_fuer_Sanitaer_und_Industrie_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.43 1.43h28.14v15.16H1.43zM63.03 56.38V34.12L29.58 56.38V23.01H1.43v77.47h95.05V34.13L63.02 56.39Z",
    className: "Ideal_fuer_Sanitaer_und_Industrie_svg__cls-1"
  }))));
};
export default SvgIdealFuerSanitaerUndIndustrie;